import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0a45cc55&style=margin-bottom%3A%20160px%3B%20margin-top%3A%2010px%3B"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports